<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">PCO Workflow Temp</h1>

    <SGPMainTabComponent>
      <SGPTabComponent title="Registros">
    <form class="filtros-container" @submit.prevent="aplicarFiltros">
      <div class="mdn-Row">
        <div class="mdn-Col-12 mdn-Col-md-4 mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            name="numero_rec"
            v-model="filtros.numero_rec"
            placeholder="Buscar por numero REC"
          />
        </div>

        <div class="mdn-Col-12 mdn-Col-md-2 mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            :name="'processado'"
            :listaDeOptions="opcoesProcessamento"
            v-model="filtros.processado"
            :optionLabel="'nome'"
            :optionSelecione="'Todos'"
            placeholder="Processamento"
          />
        </div>

        <div class="mdn-Col-12 mdn-Col-md-3 mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            :name="'tem_external'"
            :listaDeOptions="opcoesExternal"
            v-model="filtros.tem_external"
            :optionLabel="'nome'"
            :optionSelecione="'Todos'"
            placeholder="External"
          />
        </div>

        <div class="mdn-Col-12 mdn-Col-md-3 mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            :name="'com_erro'"
            :listaDeOptions="opcoesErro"
            v-model="filtros.com_erro"
            :optionLabel="'nome'"
            :optionSelecione="'Todos'"
            placeholder="Erro"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-12 mdn-Col-md-3 mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="datetime-local"
            name="created_at_inicio"
            v-model="filtros.created_at_inicio"
            placeholder="Criado de"
          />
        </div>

        <div class="mdn-Col-12 mdn-Col-md-3 mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="datetime-local"
            name="created_at_fim"
            v-model="filtros.created_at_fim"
            placeholder="Criado ate"
          />
        </div>

        <div class="mdn-Col-12 mdn-Col-md-6 mdn-u-marginTop--xs filtros-acoes">
          <button
            type="submit"
            class="v-btn v-btn--has-bg theme--light v-size--default primary text-capitalize"
          >
            Aplicar filtros
          </button>

          <button
            type="button"
            class="v-btn v-btn--outlined theme--light v-size--default grey-5--text text-capitalize"
            @click="limparFiltros"
          >
            Limpar
          </button>
        </div>
      </div>
    </form>

    <SGPPaginacaoComponent
      v-if="listaDeRegistros.length"
      :paginacao="paginacao"
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao?.current_page"
    >
      <SGPTabelaAvancadaComponent
        :colunas="colunas"
        :dados="registrosFormatados"
        :key="JSON.stringify(registrosFormatados)"
        :usuarioPodeEditar="false"
        :usuarioPodeExcluir="false"
        selecionarColunas
      >
        <template v-slot:item.acoes="{ item }">
          <button
            class="v-btn v-btn--text v-btn--icon theme--light v-size--small"
            @click="visualizarDetalhes(item)"
            title="Visualizar detalhes"
          >
            <SGPIconComponent icon="mdi-eye" />
          </button>
        </template>
      </SGPTabelaAvancadaComponent>
    </SGPPaginacaoComponent>

    <SGPAlertaComponent v-else>
      Nenhum registro encontrado para os filtros informados.
    </SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Detalhes do registro"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <VisualizarPcoWorkflowTempComponent :registro="registroSelecionado" />
    </SGPModalComponent>

    <SGPLoadingComponent v-if="loadingRegistros" />
      </SGPTabComponent>

      <SGPTabComponent v-if="ehModuloRecuperacao" title="Integração" lazy>
        <IntegracaoConfiguracaoComponent v-if="usuarioEhAdmin" />
        <IntegracaoDashboardComponent />
      </SGPTabComponent>
    </SGPMainTabComponent>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import VisualizarPcoWorkflowTempComponent from '../components/VisualizarPcoWorkflowTempComponent.vue'
import IntegracaoConfiguracaoComponent from '../components/IntegracaoConfiguracaoComponent.vue'
import IntegracaoDashboardComponent from '../components/IntegracaoDashboardComponent.vue'
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import { usuarioEhAdmin } from '@/common/helpers/usuarioPermissao'

const criarFiltrosPadrao = () => ({
  numero_rec: '',
  processado: '',
  tem_external: '',
  com_erro: '',
  created_at_inicio: '',
  created_at_fim: ''
})

export default {
  name: 'PcoWorkflowTempPage',

  components: {
    VisualizarPcoWorkflowTempComponent,
    IntegracaoConfiguracaoComponent,
    IntegracaoDashboardComponent
  },

  data() {
    return {
      abrirModal: false,
      registroSelecionado: {},
      filtros: criarFiltrosPadrao(),
      opcoesProcessamento: [
        { id: 'true', nome: 'Processado' },
        { id: 'false', nome: 'Pendente' }
      ],
      opcoesExternal: [
        { id: 'true', nome: 'Com external' },
        { id: 'false', nome: 'Sem external' },
        { id: 'null', nome: 'Nao classificado' }
      ],
      opcoesErro: [
        { id: 'true', nome: 'Com erro' },
        { id: 'false', nome: 'Sem erro' }
      ]
    }
  },

  created() {
    this.listarRegistros(this.montarParametros())
  },

  computed: {
    ...mapGetters('pcoWorkflowTemp', [
      'listaDeRegistros',
      'loadingRegistros',
      'paginacao'
    ]),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),
    ...mapGetters('login', ['usuarioLogado']),

    ehModuloRecuperacao() {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    },

    usuarioEhAdmin() {
      return usuarioEhAdmin(this.usuarioLogado)
    },

    registrosFormatados() {
      return this.listaDeRegistros.map((registro) => ({
        ...registro,
        status_processamento: this.descreverStatusProcessamento(registro),
        status_external: this.descreverStatusExternal(registro.tem_external),
        processado_em_formatado: this.formatarData(registro.processado_em),
        created_at_formatado: this.formatarData(registro.created_at)
      }))
    },

    colunas() {
      return [
        { key: 'acoes', label: 'Acoes', sortable: false, width: '100' },
        { key: 'numero_rec', label: 'Numero REC', sortable: false },
        { key: 'status_processamento', label: 'Status', sortable: false },
        { key: 'status_external', label: 'External', sortable: false },
        { key: 'tentativas_processamento', label: 'Tentativas', sortable: false },
        { key: 'processado_em_formatado', label: 'Processado em', sortable: false },
        { key: 'created_at_formatado', label: 'Criado em', sortable: false }
      ]
    }
  },

  methods: {
    ...mapActions('pcoWorkflowTemp', [
      'listarRegistros'
    ]),

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        current_page: this.paginacao?.current_page || 1,
        sort: 'created_at',
        direction: 'desc',
        ...this.normalizarFiltros(this.filtros),
        ...extra
      }
    },

    normalizarFiltros(filtros) {
      const payload = {}

      if (filtros.numero_rec) {
        payload.numero_rec = filtros.numero_rec
      }

      if (filtros.processado !== '') {
        payload.processado = filtros.processado === 'true'
      }

      if (filtros.tem_external !== '') {
        if (filtros.tem_external === 'null') {
          payload.tem_external = null
        } else {
          payload.tem_external = filtros.tem_external === 'true'
        }
      }

      if (filtros.com_erro !== '') {
        payload.com_erro = filtros.com_erro === 'true'
      }

      if (filtros.created_at_inicio) {
        payload.created_at_inicio = this.formatarDataParaApi(filtros.created_at_inicio)
      }

      if (filtros.created_at_fim) {
        payload.created_at_fim = this.formatarDataParaApi(filtros.created_at_fim)
      }

      return payload
    },

    aplicarFiltros() {
      this.listarRegistros(this.montarParametros({
        current_page: 1
      }))
    },

    limparFiltros() {
      this.filtros = criarFiltrosPadrao()
      this.listarRegistros(this.montarParametros({ current_page: 1 }))
    },

    realizarPaginacao(paginate) {
      this.listarRegistros(this.montarParametros({
        current_page: paginate.current_page || 1,
        per_page: paginate.per_page || this.paginacao?.per_page || 20
      }))
    },

    visualizarDetalhes(item) {
      this.registroSelecionado = item
      this.abrirModal = true
    },

    fecharModal() {
      this.abrirModal = false
      this.registroSelecionado = {}
    },

    descreverStatusProcessamento(registro) {
      if (registro.erro_processamento) {
        return 'Processado com erro'
      }

      return registro.processado ? 'Processado com sucesso' : 'Pendente'
    },

    descreverStatusExternal(temExternal) {
      if (temExternal === true) {
        return 'Com external'
      }

      if (temExternal === false) {
        return 'Sem external'
      }

      return 'Nao classificado'
    },

    formatarData(data) {
      if (!data) {
        return '-'
      }

      return moment(data).isValid()
        ? moment(data).format('DD/MM/YYYY HH:mm')
        : data
    },

    formatarDataParaApi(data) {
      return moment(data).isValid()
        ? moment(data).format('YYYY-MM-DD HH:mm:ss')
        : data
    }
  }
}
</script>

<style scoped>
.filtros-container {
  margin: 16px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filtros-container .mdn-Row {
  display: grid;
  grid-template-columns: minmax(200px, 2fr) repeat(3, minmax(150px, 1fr));
  gap: 12px;
  align-items: center;
  margin: 0;
}

.filtros-container .mdn-Row + .mdn-Row {
  grid-template-columns: minmax(200px, 1fr) minmax(200px, 1fr) minmax(200px, 2fr);
}

.filtros-container .mdn-Row > div {
  width: auto;
  max-width: none;
  margin: 0;
  padding: 0;
}

.filtros-container :deep(.v-text-field__details) {
  display: none !important;
}

.filtros-container :deep(.v-input) {
  margin: 0;
  padding: 0;
}

.filtros-acoes {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
}

@media (max-width: 1100px) {
  .filtros-container .mdn-Row,
  .filtros-container .mdn-Row + .mdn-Row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filtros-acoes {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .filtros-container .mdn-Row,
  .filtros-container .mdn-Row + .mdn-Row {
    grid-template-columns: 1fr;
  }

  .filtros-acoes {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>